import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { PortalIcon } from 'utils/baochauTheme';
import PromotionsProductTable from './PromotionProductTable';

const ProductPickerOverlay = styled.div`
  &&.bw_modal {
    position: fixed !important;
    inset: 0 !important;
    z-index: var(--portal-z-modal-nested, 7040) !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 100vw !important;
    height: 100vh !important;
    padding: 16px;
    background: rgba(15, 23, 42, 0.58);
    backdrop-filter: blur(6px);
  }

  .bw_promotion_product_modal {
    display: flex;
    flex-direction: column;
    width: min(1480px, calc(100vw - 32px)) !important;
    max-width: calc(100vw - 32px) !important;
    height: min(820px, calc(100vh - 32px));
    max-height: calc(100vh - 32px) !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    border-radius: 16px !important;
    background: #fff;
  }

  .bw_promotion_product_modal_header {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 60px;
    padding: 14px 20px !important;
    border-bottom: 1px solid #e4e7ec;
    background: #fff;
  }

  .bw_promotion_product_modal_header h3 {
    margin: 0 !important;
    color: #172033;
    font-size: 18px;
    font-weight: 800;
    line-height: 24px;
  }

  .bw_promotion_product_modal_header .bw_close_modal {
    position: static;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin: 0 !important;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #667085;
    font: inherit;
    cursor: pointer;
  }

  .bw_promotion_product_modal_header .bw_close_modal:hover {
    background: #f2f4f7;
    color: #d92d20;
  }

  .bw_promotion_product_modal_body {
    min-height: 0;
    flex: 1 1 auto;
    overflow: auto;
    padding: 10px 16px 12px;
  }

  .bw_promotion_product_modal_body .bw_main_wrapp {
    padding: 0;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .bw_promotion_product_modal_body .bw_box_card {
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .bw_promotion_product_modal_body
    .bw_box_card
    > .bw_row.bw_mt_2.bw_mb_2.bw_align_items_center {
    display: none !important;
  }

  .bw_promotion_product_modal_body .bw_search_box {
    margin: 0 0 8px !important;
    padding: 8px 12px !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .bw_promotion_product_modal_body .bw_title_search {
    min-height: 20px;
    margin: 0 0 5px !important;
    padding: 0 !important;
    font-size: 14px !important;
    line-height: 20px !important;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row {
    margin-top: 0 !important;
    margin-bottom: 4px !important;
    row-gap: 6px;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row > [class*='bw_col_'],
  .bw_promotion_product_modal_body .bw_search_actions_row > [class*='bw_col_'] {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box {
    margin-bottom: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box > span:first-child:not(:last-child),
  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box > label,
  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box .bw_label {
    margin-bottom: 3px !important;
    font-size: 11.5px !important;
    line-height: 15px !important;
  }

  .bw_promotion_product_modal_body
    .bw_search_fields_row
    .bw_frm_box
    input:not([type='checkbox']):not([type='radio']):not([type='file']),
  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box select,
  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box .bw_inp,
  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box .ant-input,
  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box .ant-input-affix-wrapper,
  .bw_promotion_product_modal_body .bw_search_fields_row .bw_frm_box .ant-input-number,
  .bw_promotion_product_modal_body
    .bw_search_fields_row
    .bw_frm_box
    .ant-select.ant-select
    .ant-select-selector.ant-select-selector {
    min-height: 34px !important;
    height: 34px !important;
    padding: 0 10px !important;
    border-radius: 8px !important;
    line-height: 32px !important;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row .ant-select-selection-item,
  .bw_promotion_product_modal_body .bw_search_fields_row .ant-select-selection-placeholder,
  .bw_promotion_product_modal_body .bw_search_fields_row .ant-select-selection-search-input {
    line-height: 32px !important;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row .ant-tree-select .ant-select-selector {
    display: flex !important;
    align-items: center !important;
    border: 1px solid #d6dee9 !important;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row .ant-tree-select .ant-select-selection-placeholder,
  .bw_promotion_product_modal_body .bw_search_fields_row .ant-tree-select .ant-select-selection-item {
    display: flex !important;
    align-items: center !important;
    height: 32px !important;
    line-height: 32px !important;
  }

  .bw_promotion_product_modal_body
    .bw_search_fields_row
    .ant-tree-select:hover
    .ant-select-selector,
  .bw_promotion_product_modal_body
    .bw_search_fields_row
    .ant-tree-select.ant-select-focused
    .ant-select-selector {
    border-color: #f2aaa5 !important;
    box-shadow:
      0 0 0 3px rgba(237, 50, 55, 0.1),
      0 8px 18px rgba(15, 23, 42, 0.06) !important;
  }

  .bw_promotion_product_modal_body .bw_search_fields_row .ant-tree-select input,
  .bw_promotion_product_modal_body .bw_search_fields_row .ant-tree-select input:hover,
  .bw_promotion_product_modal_body .bw_search_fields_row .ant-tree-select input:focus {
    border: 0 !important;
    outline: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .bw_promotion_product_modal_body .bw_search_actions_row {
    min-height: 34px;
    margin: 0 !important;
  }

  .bw_promotion_product_modal_body .bw_search_actions_row .bw_btn_group {
    gap: 8px;
  }

  .bw_promotion_product_modal_body .bw_search_actions_row .bw_btn_icon_only {
    width: 34px !important;
    min-width: 34px !important;
    height: 34px !important;
    min-height: 34px !important;
  }

  .bw_promotion_product_modal_body .bw_table_responsive {
    max-width: 100%;
    margin-top: 0 !important;
    padding: 0 !important;
    overflow: auto;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .bw_promotion_product_modal_body .bw_table {
    width: 100% !important;
    min-width: 1435px;
    table-layout: fixed;
  }

  .bw_promotion_product_modal_body .bw_table td,
  .bw_promotion_product_modal_body .bw_table th {
    vertical-align: middle;
  }

  .bw_promotion_product_modal_body .bw_table th {
    padding: 7px 8px !important;
    font-size: 12px !important;
    line-height: 16px !important;
  }

  .bw_promotion_product_modal_body .bw_table td {
    padding: 6px 8px !important;
    font-size: 12px !important;
    line-height: 16px !important;
  }

  .bw_promotion_product_modal_body .bw_promotion_product_text,
  .bw_promotion_product_modal_body .bw_promotion_product_text b,
  .bw_promotion_product_modal_body .bw_promotion_product_text span {
    font-size: 12px !important;
    line-height: 16px !important;
  }

  .bw_promotion_product_modal_body .bw_search_box,
  .bw_promotion_product_modal_body .bw_show_table_page {
    font-size: 12px;
  }

  .bw_promotion_product_modal_body .bw_show_table_page {
    margin: 8px 0 0 !important;
    padding: 8px 2px 0 !important;
    border-top: 1px solid #e4e7ec;
    border-radius: 0 !important;
    background: transparent !important;
  }

  .bw_promotion_product_name_col,
  .bw_promotion_product_name_col > span,
  .bw_promotion_product_info,
  .bw_promotion_product_text {
    min-width: 0;
    max-width: 100%;
  }

  .bw_promotion_product_name_col {
    overflow: hidden;
    white-space: normal !important;
  }

  .bw_promotion_product_name_col > span {
    display: block;
    width: 100%;
    white-space: normal !important;
  }

  .bw_promotion_product_info {
    align-items: flex-start;
  }

  .bw_promotion_product_text b,
  .bw_promotion_product_text span {
    display: block;
    max-width: 100%;
    white-space: normal !important;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .bw_promotion_product_text_col,
  .bw_promotion_product_text_col > span {
    min-width: 0;
    max-width: 100%;
    white-space: normal !important;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .bw_promotion_product_text_col > span {
    display: block;
    width: 100%;
  }

  .bw_promotion_product_modal_footer {
    position: relative;
    z-index: 2;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    min-height: 64px;
    margin: 0 !important;
    padding: 12px 20px !important;
    border-top: 1px solid #e4e7ec;
    background: #fff;
    box-shadow: 0 -8px 20px rgba(15, 23, 42, 0.08);
  }

  @media (max-width: 768px) {
    &&.bw_modal {
      padding: 8px;
    }

    .bw_promotion_product_modal {
      width: calc(100vw - 16px) !important;
      max-width: calc(100vw - 16px) !important;
      height: calc(100vh - 16px);
      max-height: calc(100vh - 16px) !important;
    }
  }
`;

const PromotionProductModal = ({
  onClose,
  fieldProduct,
  title = 'Chọn sản phẩm áp dụng khuyến mãi',
}) => {
  const methods = useFormContext();
  const [selectedProducts, setSelectedProducts] = useState(() => methods.getValues(fieldProduct) || []);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  const handleAccept = () => {
    methods.setValue(fieldProduct, selectedProducts, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    onClose();
  };

  return createPortal(
    <ProductPickerOverlay
      className='bw_modal bw_modal_open'
      role='dialog'
      aria-modal='true'
      aria-labelledby='promotion-product-picker-title'>
      <div className='bw_modal_container bw_promotion_product_modal'>
        <div className='bw_title_modal bw_promotion_product_modal_header'>
          <h3 id='promotion-product-picker-title'>{title}</h3>
          <button type='button' onClick={onClose} className='bw_close_modal' aria-label='Đóng popup chọn sản phẩm'>
            <PortalIcon icon='fi fi-rr-cross-small' />
          </button>
        </div>

        <div className='bw_promotion_product_modal_body'>
          <PromotionsProductTable
            fieldProduct={fieldProduct}
            hiddenAction={{ detail: true, delete: true }}
            onSelectionChange={setSelectedProducts}
          />
        </div>

        <div className='bw_footer_modal bw_promotion_product_modal_footer'>
          <button type='button' onClick={onClose} className='bw_btn_outline'>
            Đóng
          </button>
          <button type='button' className='bw_btn bw_btn_success' onClick={handleAccept}>
            <PortalIcon icon='fi fi-rr-check' /> Lưu lựa chọn
          </button>
        </div>
      </div>
    </ProductPickerOverlay>,
    document.getElementById('bw_modal_root') || document.body,
  );
};

export default PromotionProductModal;
